// JOBE-0098.3: parser receipt row — reads the parser output back as a
// chain of `.frag` chips. Always present when ≥1 token in the input.

export function ParserReceipt({ parsed }) {
  if (!parsed) return null;
  const hasContent =
    (parsed.predicates && parsed.predicates.length > 0) ||
    (parsed.unrecognized && parsed.unrecognized.length > 0) ||
    (parsed.fuzzyFragment && parsed.fuzzyFragment.trim());
  if (!hasContent) return null;

  return (
    <div className="omni-parsed" aria-label="Parsed query">
      <span className="omni-parsed-label">Parsed</span>
      <span className="omni-parsed-chain">
        {parsed.predicates.map((p, i) => (
          <span key={`p${i}`} className="omni-frag omni-frag-pred">
            <span className="omni-frag-tok">{p.friendlyToken}</span>
            <span className="omni-frag-eq">≡</span>
            <span className="omni-frag-wire">{p.rawPredicate}</span>
            <span className="omni-frag-op">{p.op}</span>
            <span className="omni-frag-val">{(p.values || []).join(',') || '·'}</span>
          </span>
        ))}
        {parsed.unrecognized.map((u, i) => (
          <span
            key={`u${i}`}
            className="omni-frag omni-frag-unrec"
            data-reason={u.reason}
          >
            {u.text}
          </span>
        ))}
        {parsed.fuzzyFragment && (
          <span className="omni-frag omni-frag-txt">{parsed.fuzzyFragment}</span>
        )}
      </span>
    </div>
  );
}
